import React from 'react';
import PropTypes from 'prop-types';
import trimEnd from 'lodash/trimEnd';
import trimStart from 'lodash/trimStart';
import Image from '../Image';
import './styles.css';

const createImageUrl = (src) => {
  // when embedded in NavStudent, the document base url differs from the hubs url where assets are hosted
  const baseUrl =
    global.__webpack_hubs_public_path__ || global.__webpack_public_path__ || '';
  if (!baseUrl) return src;
  const sanitizedBaseUrl = trimEnd(baseUrl, '/');
  const sanitizedSrc = trimStart(src, '/');
  return `${sanitizedBaseUrl}/${sanitizedSrc}`;
};

export default function EduLogo({ src, alt, width, height }) {
  return (
    <div className="eduLogo-container">
      <Image src={createImageUrl(src)} alt={alt} width={width} height={height} />
    </div>
  );
}

EduLogo.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};
